<template>
  <div class="def-switch" :style="`--slots: ${slotCount}; --activeIndex: ${activeIndex}`">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DefSwitch',
  props: ['result'],
  data() {
    return {
      activeIndex: 0,
      slotCount: 0,
    };
  },
  mounted() {
    this.activeIndex = this.getActiveIndex();
    this.slotCount = this.getSlots().length;

    const observer = new MutationObserver(() => {
      this.activeIndex = this.getActiveIndex();
    });

    Array.from(this.$el?.children).forEach((el) =>
      observer.observe(el, {
        attributes: true,
      })
    );
  },
  methods: {
    getSlots() {
      return this.$slots?.default()?.filter((el) => el?.type);
    },
    getActiveIndex() {
      return this.getSlots().findIndex((el) => el?.props?.class.includes('active'));
    },
  },
};
</script>

<style lang="scss" scoped>
.def-switch {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  position: relative;
  border: 1px solid #030304;
  background-color: var(--ct);
  overflow: hidden;
  :deep(button) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    background-color: transparent;
    font-weight: 600;
    font-size: rem(12);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    transition: 0.3s linear color;
    min-height: 32px;
    position: relative;
    z-index: 1;
    &.active {
      color: #fff;
    }
    &:first-child {
      border-right: 1px solid #030304;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: calc(100% / var(--slots));
    background-color: var(--background-black);
    //z-index: -1;
    left: calc(100% / var(--slots) * var(--activeIndex));
    transition: 0.3s linear left;
  }
}
</style>
